/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMoneyCancel = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M13 2v2h5v2h-5v5h2.5a4.5 4.5 0 0 1 4.454 3.858l-1.98.284A2.5 2.5 0 0 0 15.5 13H13v5h2v2h-2v2h-2v-2H5v-2h6v-5H8.5a4.5 4.5 0 1 1 0-9H11V2zM6 8.5A2.5 2.5 0 0 0 8.5 11H11V6H8.5A2.5 2.5 0 0 0 6 8.5z" />
        <path d="M23.707 17.707 21.414 20l2.293 2.293-1.414 1.414L20 21.414l-2.293 2.293-1.414-1.414L18.586 20l-2.293-2.293 1.414-1.414L20 18.586l2.293-2.293z" />
      </g>
    </g>
  </Icon>
);
export { SvgMoneyCancel as MoneyCancel };
